import { defineMessages } from 'react-intl';

const messages = defineMessages({
  import: '导入',
  show: '查看',
  edit: '编辑',
  delete: '删除',
  deleteSuccess: '删除成功',
  create: '创建',
  new: '新建',
  save: '保存',
  saveSuccess: '保存成功',
  back: '返回',
  saveDraft: '保存草稿',
  submit: '提交',
  confirm: '确认',
  cancel: '取消',
  rollBack: '退回',
  redmind: '提醒',
  download: '下载',
  operation: '操作',
  addDemand: '新建需求',
  logOut: '退出',
  remark: '备注',
  okText: '确定',
  cancelText: '取消',
  ISeeText: '我知道了',
  required: '必填',
  invlid: '无效',
  error: '错误',
  success: '成功',
  yes: '是',
  no: '否',
  true: '是',
  false: '否',
  inputPlaceholder: '请输入',
  // 页面修改后离开时的title
  pageLeaveTipTitle: '温馨提示',
  // 页面修改后离开时的提示内容
  pageLeaveTipContent: '您确定要取消编辑吗？系统将不会保存您所做的更改！',
  // 文件大小过大
  fileExceededLimit: '文件过大,{filename}大小超过{fileMaxSize}！',
  menuOverflowedIndicator: '更多...',
  comma: '，',
  comma_alias: '、',
  colon: '：',
  questionMark: '？',
  bracketsWrap: '（{content}）',
  notBidBudgesNotes: '非比选且预算超100万的补充说明',
  pass: '通过',
  notice: '备注',
  'currency.rmb': '人民币',
  'currency.usd': '美元',
  'currency.eur': '欧元',
  'currency.gbp': '英镑',
  'currency.jpy': '日元',
  'currency.hkd': '港币',
  'currency.twd': '新台币',
  "currency.myr": "林吉特",
  requiredCheckTips: '必填项不能为空!',
  serverErrorTips: '服务器错误',
  query: '查询',
  export: '导出',
  notFoundPageMessage: '我走丢了',
  audit: '审核',
  selectAll: '- 全部 -',
  failed: '失败',
  preferences: '偏好设置',
  changeSupplier: '切换供应商身份',
  language: '语言',
  'timingUnit.day': `{num, plural,
    0 { 天 }
    1 { 天 }
    other { 天 }
  }`,
  'timingUnit.hour': `{num, plural,
    0 { 小时 }
    1 { 小时 }
    other { 小时 }
  }`,
  'timingUnit.minute': `{num, plural,
    0 { 分钟 }
    1 { 分钟 }
    other { 分钟 }
  }`,
  'timingUnit.second': `{num, plural,
    0 { 秒 }
    1 { 秒 }
    other { 秒 }
  }`,
  toBeProcessed: '待处理',
  haveToDealWith: '已处理',
});

export default messages;
